<template>
  <timesheet-page :pageType="pageType"/>
</template>

<script>
import TimesheetPage from './../TimesheetPage'

export default {
  name: 'dashboard',
  components: {
    TimesheetPage,
  },
  data () {
    return {
      pageType: '',
    }
  },
  async created () {
    await this.initialize()
  },
  methods: {
    async initialize () {
      this.pageType = 'tobeprocessed'
    },
  },
}
</script>
